import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { ROUTE_PERMS } from './core/auth/security-domains';

export const routes: Routes = [
  // Rutas de autenticación (sin protección)
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'request-demo',
    loadComponent: () => import('./features/auth/demo-request.component').then(m => m.DemoRequestComponent)
  },
  {
    path: 'callback',
    loadComponent: () => import('./features/auth/callback.component').then(m => m.CallbackComponent)
  },
  // Hasta el 24-10-2026 existía aquí `graph-public`, una copia de /graph SIN AuthGuard
  // («TEMP: ruta pública para pruebas sin login») que nadie enlazaba y que se desplegaba
  // en producción. Si hace falta probar el grafo sin sesión, es cosa de un entorno local,
  // no de una ruta pública en el bundle.

  // Rutas principales (con layout/sidebar y protegidas)
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'agent',
        pathMatch: 'full'
      },
      {
        // El dashboard antiguo ya no existe: /metrics lo sustituyó y nada enlazaba a él
        // (solo se llegaba escribiendo la URL). Su código se borró el 24-10-2026 tras un
        // mes sin ruta; la redirección se queda para los marcadores antiguos.
        path: 'dashboard',
        redirectTo: 'metrics',
        pathMatch: 'full'
      },
      {
        path: 'metrics',
        loadComponent: () => import('./features/metrics/metrics.component').then(m => m.MetricsComponent)
      },
      {
        path: 'graph',
        loadComponent: () => import('./features/graph/graph.component').then(m => m.GraphComponent)
      },
      {
        // Registro del conocimiento del context-graph (fase 2 interpretabilidad).
        // Vive como pestaña de /graph, que es quien pone la cabecera (page-hero);
        // la ruta suelta se mantiene por los enlaces antiguos y redirige allí.
        path: 'knowledge',
        redirectTo: '/graph?tab=knowledge'
      },
      {
        path: 'events',
        canActivate: [permissionGuard],
        data: { perm: ROUTE_PERMS['/events'] },
        loadComponent: () => import('./features/events/events.component').then(m => m.EventsComponent)
      },
      {
        path: 'alerts',
        canActivate: [permissionGuard],
        data: { perm: ROUTE_PERMS['/alerts'] },
        loadChildren: () => import('./features/alerts/alerts.routes').then(m => m.ALERTS_ROUTES)
      },
      {
        path: 'identities',
        canActivate: [permissionGuard],
        data: { perm: ROUTE_PERMS['/identities'] },
        loadChildren: () => import('./features/identities/identities.routes').then(m => m.IDENTITIES_ROUTES)
      },
      {
        path: 'integrations',
        canActivate: [permissionGuard],
        data: { perm: ROUTE_PERMS['/integrations'] },
        loadComponent: () => import('./features/integrations/integrations.component').then(m => m.IntegrationsComponent)
      },
      {
        // Vuelta del OAuth del autoprovisioning (SYN-806): mismos guards que /integrations.
        path: 'integrations/oauth/callback',
        canActivate: [permissionGuard],
        data: { perm: ROUTE_PERMS['/integrations'] },
        loadComponent: () =>
          import('./features/integrations/autoprovisioning-oauth-callback.component').then(
            m => m.AutoprovisioningOauthCallbackComponent
          )
      },
      {
        path: 'third-party-integrations',
        canActivate: [permissionGuard],
        data: { perm: ROUTE_PERMS['/third-party-integrations'] },
        loadComponent: () => import('./features/third-party-integrations/tpi.component').then(m => m.TpiComponent)
      },
      {
        path: 'agent',
        loadComponent: () => import('./features/agent/agent.component').then(m => m.AgentComponent)
      },
      {
        // Historial completo del agente («Ver todas», app#690): búsqueda,
        // filtro Todo/Chats/Alertas y selección para borrar en lote.
        path: 'agent/historial',
        loadComponent: () => import('./features/agent/history-page.component').then(m => m.AgentHistoryPageComponent)
      },
      {
        path: 'settings',
        loadComponent: () => import('./features/settings/settings.component').then(m => m.SettingsComponent)
      },
      {
        path: 'design-showcase',
        loadComponent: () => import('./features/design-showcase/design-showcase.component').then(m => m.DesignShowcaseComponent)
      }
    ]
  },

  // Ruta por defecto
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full'
  }
];
